import { render, staticRenderFns } from "./SocialStatuseTable.vue?vue&type=template&id=d0ff2fe0&"
import script from "./SocialStatuseTable.vue?vue&type=script&lang=js&"
export * from "./SocialStatuseTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports